import { ReactNode } from "react";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import styled from "styled-components";
import { useChatLauncherContext } from "@/src/shared/ChatLauncher/ChatLauncherContext";
import squintAnimation from "@/public/lottie/niora/Squint.json";

const Lottie = dynamic(() => import("lottie-react"), { ssr: false });

const ChatHeader = (): ReactNode => {
  const { close } = useChatLauncherContext();
  const { t } = useTranslation();

  return (
    <StyledChatHeader>
      <Lottie
        animationData={squintAnimation}
        className="chatbot"
        style={{
          width: 60,
          height: 60,
          margin: "6px -14px -4px -14px"
        }}
      />
      <span>{t("chatWidget.headerTitle")}</span>
      <StyledChatHeaderCloseButton onClick={close}>
        <i className="feather-x"></i>
      </StyledChatHeaderCloseButton>
    </StyledChatHeader>
  );
};

const StyledChatHeader = styled.div`
  flex: none;
  height: 60px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 20px;
  color: #fff;
  font-size: 16px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background: linear-gradient(252deg, rgba(25, 35, 53, 0) 35.97%, rgba(47, 87, 239, 1) 100.98%),
    linear-gradient(110deg, rgba(25, 35, 53, 0) 10%, rgba(185, 102, 231, 1) 102.05%);
`;

const StyledChatHeaderCloseButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  width: 40px;
  height: 40px;
  position: absolute;
  right: 4px;
  border-radius: 100px;
  font-size: 20px;
`;

export default ChatHeader;
